import { BaseState } from '@/store/base-state';
import { Reports } from '@/modules/reports/types';

export default class ReportsRepairsState extends BaseState {
  reports_dates: Reports.RepairsDate = {};
  reports_list: Reports.Repair[] = [];
  report_request_date: Reports.RepairsPayload = {} as Reports.RepairsPayload;
  organization_id: number | null = null;
  organization_name: string | null = null;
}
